import { render, staticRenderFns } from "./processoAberto.vue?vue&type=template&id=bc3aca58"
import script from "./processoAberto.vue?vue&type=script&lang=js"
export * from "./processoAberto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports